import React from "react";
import { Box, Typography } from "@mui/material";
import { ISessionDetails } from "../../models/admin/conversationAnalysis/conversationAnalysis";
import { ConversationAnalysisStyles } from "./ConversationAnalysisStyles";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";

interface ISessionDetailsCardProps {
  session: ISessionDetails;
  onSelectSession: (sessionId: string) => void;
}

const SessionDetailsCard: React.FC<ISessionDetailsCardProps> = ({
  session,
  onSelectSession,
}) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return "-";
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    } as const;

    // Format the date using toLocaleString
    return date.toLocaleString("en-US", options);
  };
  return (
    <Box
      sx={ConversationAnalysisStyles.sessionDetailsCardContainer}
      onClick={() => onSelectSession(session?.sessionId)}
      id={`session_details_card_${session?.sessionId}`}
      data-test-id={`session_details_card_${session?.sessionId}`}
      aria-label={`Session Details: ${session?.emailId || 'NA'}`}
      role="button"
      tabIndex={0}
    >
      <Box 
        sx={ConversationAnalysisStyles.sessionEmailContainer}
        id={`session_details_email_${session?.sessionId}`}
        data-test-id={`session_details_email_${session?.sessionId}`}
        aria-label="Session Contact Information"
      >
        <EmailOutlinedIcon fontSize="small" /> {"/"}
        <LocalPhoneOutlinedIcon fontSize="small" />
        <Typography 
          sx={{ fontSize: "0.9rem" }}
          id={`session_details_email_text_${session?.sessionId}`}
          data-test-id={`session_details_email_text_${session?.sessionId}`}
          aria-label={`Contact: ${session?.emailId || 'NA'}`}
        >
          {session?.emailId || "NA"}
        </Typography>
      </Box>
      <Box 
        sx={ConversationAnalysisStyles.sessionDatesContianer}
        id={`session_details_dates_${session?.sessionId}`}
        data-test-id={`session_details_dates_${session?.sessionId}`}
        aria-label="Session Time Period"
      >
        <Box 
          sx={ConversationAnalysisStyles.sessionDateAndIcon}
          id={`session_details_start_time_${session?.sessionId}`}
          data-test-id={`session_details_start_time_${session?.sessionId}`}
          aria-label={`Session Start Time: ${formatDate(session?.startTime) || 'NA'}`}
        >
          {"From"}
          <AccessTimeOutlinedIcon fontSize="small" />
          <Typography sx={{ fontSize: "14px" }}>
            {formatDate(session?.startTime) || "NA"}
          </Typography>
        </Box>
        <Box 
          sx={ConversationAnalysisStyles.sessionDateAndIcon}
          id={`session_details_end_time_${session?.sessionId}`}
          data-test-id={`session_details_end_time_${session?.sessionId}`}
          aria-label={`Session End Time: ${formatDate(session?.endTime) || 'NA'}`}
        >
          {"To"}
          <AccessTimeOutlinedIcon fontSize="small" />
          <Typography sx={{ fontSize: "14px" }}>
            {formatDate(session?.endTime) || "NA"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SessionDetailsCard;
